/**
 * @fileoverview Horário de atendimento: a semana e os feriados da empresa. Valem
 * sempre no atendimento (feriado → horário próprio da conexão → semana da
 * empresa) e no tempo de resposta; só admin (ou super) muda. A seção não espera
 * a carga da área: os feriados buscam os seus dados em paralelo e só a semana
 * espera a empresa.
 */

import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";

import SettingsSection from "../../../components/Settings/SettingsSection";
import { LoadError, LoadingState } from "../../../components/Settings/LoadState";
import SchedulesForm from "../../../components/SchedulesForm";
import ScheduleExceptionsManager from "../../../components/ScheduleExceptionsManager";
import useCompanies from "../../../hooks/useCompanies";
import toastError from "../../../errors/toastError";
import { i18n } from "../../../translate/i18n";

// O SchedulesForm tem um respiro próprio de 8px (também é usado no modal da
// conexão): aqui ele é desfeito para os cartões alinharem com o título.
const useStyles = makeStyles({ weekForm: { margin: "-8px -8px 0" } });
const t = (key) => i18n.t(`settings.sections.schedules.${key}`);

const Schedules = ({ area, onDirtyChange }) => {
  const classes = useStyles();
  const { updateSchedules } = useCompanies();
  const [savingHours, setSavingHours] = useState(false);

  // Salvar gira só o botão (antes a página inteira virava um spinner) e a
  // semana salva só passa a valer na tela depois que o servidor aceitou.
  const saveHours = async (schedules) => {
    setSavingHours(true);
    try {
      const updated = await updateSchedules({ id: area.company.id, schedules });
      area.updateCompany({ schedules: updated?.schedules || schedules });
      toast.success(i18n.t("settings.schedulesUpdated"));
    } catch (err) {
      toastError(err);
    } finally {
      setSavingHours(false);
    }
  };

  return (
    <>
      <SettingsSection
        plain
        settingId="weeklyHours"
        title={t("fields.weeklyHours.title")}
        description={t("fields.weeklyHours.description")}
      >
        {area.status === "ready" ? (
          <div className={classes.weekForm}>
            <SchedulesForm
              initialValues={area.company?.schedules}
              onSubmit={saveHours}
              loading={savingHours}
              onDirtyChange={onDirtyChange}
            />
          </div>
        ) : area.status === "error" ? (
          <LoadError onRetry={area.reload} />
        ) : (
          <LoadingState />
        )}
      </SettingsSection>
      <SettingsSection
        plain
        settingId="exceptions"
        title={t("fields.exceptions.title")}
        description={t("fields.exceptions.description")}
      >
        <ScheduleExceptionsManager />
      </SettingsSection>
    </>
  );
};

export default Schedules;
